import TSettingBusinessHoursEditHoursOnHoliday from './index.vue';

TSettingBusinessHoursEditHoursOnHoliday.install = app => {
  app.component(TSettingBusinessHoursEditHoursOnHoliday.name, TSettingBusinessHoursEditHoursOnHoliday);
};

export default TSettingBusinessHoursEditHoursOnHoliday;
